var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'lowpadding': !_vm.showLayout },attrs:{"id":"app"}},[_c('Icons'),(_vm.showLayout)?[_c('Head',{attrs:{"logged":_vm.isLogged}})]:_vm._e(),_c('router-view'),(_vm.showLayout)?[_c('Foot')]:_vm._e(),_c('PreviewOverlay'),_c('LoginForm'),_c('OverlayForms'),_c('OverlaySession')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }